import React from 'react';
import { useTranslation } from '@lt/localization';
import { LogoRenessans } from '@lt/components/icons-react/userflow/package';

import styled from 'styled-components';
import ExtraItem from './components/ExtraItem';

import { InsuranceDescription } from './components/InsuranceDescription';
import type { PropsFromRedux } from '.';

export const ExtraInsurance = (
  props: PropsFromRedux & { className?: string },
): JSX.Element | null => {
  const {
    insurable,
    insurancePrice,
    selectedInsurance,
    toggleInsurance,
    isTouristsSkipDoc,
    searchType,
    className = '',
  } = props;
  const { t } = useTranslation();

  if (!insurable) return null;

  return (
    <div className={`checkout-service-block ${className}`}>
      <h2 className="like-h2">{t('checkout.services.cancellationPolicy')}</h2>

      <ul>
        <ExtraItem
          selected={Boolean(selectedInsurance)}
          price={insurancePrice}
          hashsum="renins_cancellation"
          name={t('checkout.services.insuranceName')}
          onChange={toggleInsurance}
          description={<InsuranceDescription searchType={searchType} />}
        >
          <StyledTitle>
            <LogoRenessans width={300} />
          </StyledTitle>

          {selectedInsurance && isTouristsSkipDoc && (
            <StyledDanger>
              {t('checkout.services.insuranceWithoutDocs')}
            </StyledDanger>
          )}
        </ExtraItem>
      </ul>
    </div>
  );
};

const StyledTitle = styled.div`
  padding: 15px;
  display: flex;
  box-sizing: border-box;
  height: 73px;
  align-items: center;
  background: #50287d;
`;

const StyledDanger = styled.div`
  margin: 5px;
  padding: 8px 10px;
  font-size: 14px;
  white-space: pre-line;
  color: #17181a;
  background: #f9eaec;
  border-radius: 4px;
`;
